import React, { Component } from 'react';
import LazyLoad from 'react-lazyload';
import semblanzas from '../data/semblanzas';
import { BASE_URL } from '../constants';
import './Semblanzas.css';

const Semblanzas = class extends Component {
  constructor() {
    super();
    this.scrollIt = this.scrollIt.bind(this);
  }

  componentDidMount() {
    this.scrollIt();
  }

  scrollIt = () => {
    setTimeout(() => {
      document.querySelector('.content-wrapper.semblanzas').scroll(0, 1);
    }, 1);
  };

  render() {
    return semblanzas.map((bio, index) => {
      const { artista, foto, texto } = bio;
      return (
        <div className={`semblanza ${artista}`} key={`${artista}`}>
          <h2>{artista.toUpperCase()}</h2>
          <LazyLoad
            scrollContainer='.content-wrapper.semblanzas'
            height={405}
            offset={100}
            once
          >
            <img src={`${BASE_URL}/images/large/${foto}.jpg`} alt='' />
          </LazyLoad>
          <p>{texto}</p>
        </div>
      );
    });
  }
};

export default Semblanzas;
